import Vue from 'vue'
import { Mixin } from 'vue-mixin-decorator'
import { Watch } from 'vue-property-decorator'

@Mixin
export default class LoadingMixin extends Vue {
  @Watch('isLoading', { immediate: true })
  /**
   * 状態遷移に応じてローディング状態を自動で切り替える.
   *
   * @param {boolean} newStateIsLoading
   * コンポーネント変化後の状態または初期状態.
   * immediate: true によってコンポーネント初期化中にも実行される関係上、初期状態の場合もある.
   * @param {boolean|undefined} oldState
   * コンポーネント変化前の状態または初期化前のundefined.
   * immediate: true によってコンポーネント初期化中にも実行される関係上、undefinedのケースもある.
   * It is advised to implement the isLoading hook method at the user components of Loading.ts
   * If necessary. Becuase having a default method here creates ordering issue between mixins
   */
  async onUpdateStatus(newStateIsLoading: boolean, oldState?: boolean) {
    const initialAndNotLoading = oldState === undefined && !newStateIsLoading
    if (initialAndNotLoading) {
      return
    }

    if (newStateIsLoading) {
      await this.$store.dispatch('view/startLoading')
    } else {
      await this.$store.dispatch('view/stopLoading')
    }
  }
}

/**
 * @note 既存実装では使い分けが徹底されていない可能性あり.その場合、↓にかかれている方針で使い分けるように変更して良い.
 */
export enum Status {
  /**
   * ユーザー入力や初期化処理実行前など、何かしらの動作を待機している状態
   */
  Pending,
  /**
   * 処理が失敗して、続行不可能になった状態
   */
  Failed,
  /**
   * 全ての処理が完了して、以降続行する必要があるものが無くなった状態
   * @note ↑のような状態に画面がなったなら、基本的には画面遷移等が発生するだろうから、UI側では不要?
   */
  Completed,
  /**
   * 処理が実行中で、新たに別の処理を受付できない状態.
   */
  Loading,
}
